import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,900;1,900&display=swap');

  *{
    margin:0;
    padding:0;
    box-sizing:border-box;
  }
  html{
    font-size:62.5%;
    scroll-behavior:smooth;
  }
  body{
    font-size:1.6rem;
    font-family: ${({ theme }) => theme.font.family.default};
  }
  h1,h2,h3,h4,h5,h6{
    font-family: 'Montserrat', sans-serif;
    margin:${({ theme }) => theme.spacings.large} 0;
  }
  p{
    margin:${({ theme }) => theme.spacings.medium} 0;
  }
  ul,ol{
    margin:${({ theme }) => theme.spacings.medium} 0;
    padding:${({ theme }) => theme.spacings.medium} 0;
  }
  a{
    color:${({ theme }) => theme.colors.secondaryColor} 0;
  }
  .table{
    width:100%;
    overflow-y:auto;
  }
`;
